import CreateSetupBackend from "../config/config.js";

let SetupBackend = null;

// Código de devolução Pix do Bacen para "devolução solicitada pelo usuário
// recebedor" — é o caso do cliente que devolve, total ou parcialmente, um Pix
// que recebeu. AM09 (valor incorreto) fica disponível para quem quiser marcar
// a devolução como correção de valor.
const DEFAULT_REFUND_CODE = "MD06";

function normalizeAmountValue(value) {
  const parsed = Number(String(value ?? 0).replace(",", "."));
  if (Number.isNaN(parsed) || parsed <= 0) {
    return "0";
  }
  return parsed.toFixed(2);
}

/**
 * Servico de Refund (Gowd)
 * Utiliza o endpoint /v1/baas/order-refunds via Higher-API Gateway
 */
function create(data) {
  SetupBackend = CreateSetupBackend();
  const email = sessionStorage.getItem("emailUser");
  const externalId = data?.externalId || `refund-${Date.now()}`;

  const payload = {
    orderId: data?.orderId,
    externalId,
    amount: {
      currency: data?.currency || "BRL",
      value: normalizeAmountValue(data?.amount),
    },
    refundCode: data?.refundCode || DEFAULT_REFUND_CODE,
    description: String(data?.description || "").trim() || "Devolução de Pix",
    // A Gowd usa o idempotencyKey para descartar reenvios: derivá-lo do
    // externalId evita que um duplo clique gere duas devoluções.
    idempotencyKey: data?.idempotencyKey || externalId,
  };

  const refundReason = String(data?.refundReason || "").trim();
  if (refundReason) {
    payload.refundReason = refundReason;
  }

  const twoFactorQuery = data?.twoFactorCode
    ? `&twoFactorCode=${encodeURIComponent(data.twoFactorCode)}`
    : "";
  const url = `/v1/baas/order-refunds?email=${encodeURIComponent(
    email,
  )}${twoFactorQuery}`;

  return SetupBackend.post(url, payload)
    .catch((err) => {
      // Mesmo tratamento do pay-out: em alguns ambientes o binding do gateway
      // espera o corpo embrulhado em `request` e responde 400 apontando o campo.
      const requiresRequestWrapper =
        err?.response?.status === 400 &&
        Array.isArray(err?.response?.data?.errors?.request);

      if (!requiresRequestWrapper) {
        throw err;
      }

      return SetupBackend.post(url, { request: payload });
    })
    .then((res) => ({
      ...res,
      data: {
        ...(res?.data || {}),
        body: res?.data?.body || res?.data,
      },
    }));
}

const backendServices = {
  create,
  DEFAULT_REFUND_CODE,
};

export default backendServices;
